import { useCallback } from "react";
import {
  useEnablePromotion,
  useDisablePromotion,
} from "../mutations/useStatusPromotionToggle.mutation";

export const usePromotionStatusToggle = () => {
  const enableMutation = useEnablePromotion();
  const disableMutation = useDisablePromotion();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleEnable,
    isEnabling: enableMutation.isPending,
    handleDisable,
    isDisabling: disableMutation.isPending,
  };
};
